import { Action } from '@ngrx/store';

export enum CalendarActionTypes {
  INIT_VISITOR_CALENDAR = '[Cyclops Calendar] Init Visitor Calendar',
  INIT_INCIDENT_CALENDAR = '[Cyclops Calendar] Init Incident Calendar',
  GET_CALENDAR_DIMENSIONS = '[Cyclops Calendar] Get Calendar Dimensions',
  GET_TIME_SLOTS = '[Cyclops Calendar] Get Time Slots',
  GET_TIME_SLOTS_SUCCESS = '[Cyclops Calendar] Get Time Slots Success',
  GET_TIME_SLOTS_FAILURE = '[Cyclops Calendar] Get Time Slots Failure',
  GET_HOSTS = '[Cyclops Calendar] Get Host',
  GET_HOSTS_SUCCESS = '[Cyclops Calendar] Get Host Success',
  GET_HOSTS_FAILURE = '[Cyclops Calendar] Get Host Failure',
  SELECTED_DATE_TIME_SLOT = '[Cyclops Calendar] Selected Date Time Slot',
  INIT_VISITOR_INVITE = '[Cyclops Calendar] Init Visitor Invite',
  CREATE_NEW_VISITOR_INVITE = '[Cyclops Calendar] Create New Visitor Invite',
  CREATE_NEW_VISITOR_INVITE_SUCCESS = '[Cyclops Calendar] Create New Visitor Invite Success',
  CREATE_NEW_VISITOR_INVITE_FAILURE = '[Cyclops Calendar] Create New Visitor Invite Failure',
  SET_CONTEXT_DATA = '[Cyclops Calendar] Set Context Data',
  CANCEL_VISITOR_INVITE = '[Cyclops Calendar] Cancel Visitor Invite',
  HOST_VISITOR_VERIFY = '[Cyclops Calendar]Host Visitor Verify',
  HOST_VISITOR_VERIFY_SUCCESS = '[Cyclops Calendar]Host Visitor Verify Success',
  HOST_VISITOR_VERIFY_FAILURE = '[Cyclops Calendar]Host Visitor Verify Failure',

  CHECK_EXISTING_VISITOR = '[Cyclops Calendar] Check Existing Visitor',
  CHECK_EXISTING_VISITOR_SUCCESS = '[Cyclops Calendar] Check Existing Visitor Success',
  CHECK_EXISTING_VISITOR_FAILURE = '[Cyclops Calendar] Check Existing Visitor Failure',

  RESET_STATE = '[Cyclops Calendar] Reset State',
}
export class ResetState implements Action {
  readonly type = CalendarActionTypes.RESET_STATE;
  constructor(public payload: any) {}
}
export class InitVisitorCalendar implements Action {
  readonly type = CalendarActionTypes.INIT_VISITOR_CALENDAR;
  constructor(public payload: any) {}
}
export class InitIncidentCalendar implements Action {
  readonly type = CalendarActionTypes.INIT_INCIDENT_CALENDAR;
  constructor(public payload: any) {}
}
export class GetCalendarDimensions implements Action {
  readonly type = CalendarActionTypes.GET_CALENDAR_DIMENSIONS;
  constructor(public payload: any) {}
}
export class CheckExistingVisitor implements Action {
  readonly type = CalendarActionTypes.CHECK_EXISTING_VISITOR;
  constructor(public payload: any) {}
}
export class CheckExistingVisitorSuccess implements Action {
  readonly type = CalendarActionTypes.CHECK_EXISTING_VISITOR_SUCCESS;
  constructor(public payload: any) {}
}
export class CheckExistingVisitorFailure implements Action {
  readonly type = CalendarActionTypes.CHECK_EXISTING_VISITOR_FAILURE;
  constructor(public payload: any) {}
}
export class GetTimeSlots implements Action {
  readonly type = CalendarActionTypes.GET_TIME_SLOTS;
  constructor(public payload: any) {}
}
export class GetTimeSlotsSuccess implements Action {
  readonly type = CalendarActionTypes.GET_TIME_SLOTS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetTimeSlotsFailure implements Action {
  readonly type = CalendarActionTypes.GET_TIME_SLOTS_FAILURE;
  constructor(public payload: any) {}
}
export class GetHosts implements Action {
  readonly type = CalendarActionTypes.GET_HOSTS;
  constructor(public payload: any) {}
}
export class GetHostsSuccess implements Action {
  readonly type = CalendarActionTypes.GET_HOSTS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetHostsFailure implements Action {
  readonly type = CalendarActionTypes.GET_HOSTS_FAILURE;
  constructor(public payload: any) {}
}
export class HostVisitorVerify implements Action {
  readonly type = CalendarActionTypes.HOST_VISITOR_VERIFY;
  constructor(public payload: any) {}
}
export class HostVisitorVerifySuccess implements Action {
  readonly type = CalendarActionTypes.HOST_VISITOR_VERIFY_SUCCESS;
  constructor(public payload: any) {}
}
export class HostVisitorVerifyFailure implements Action {
  readonly type = CalendarActionTypes.HOST_VISITOR_VERIFY_FAILURE;
  constructor(public payload: any) {}
}
export class SelectedDateTimeSlot implements Action {
  readonly type = CalendarActionTypes.SELECTED_DATE_TIME_SLOT;
  constructor(public payload: any) {}
}
export class InitVisitorInvite implements Action {
  readonly type = CalendarActionTypes.INIT_VISITOR_INVITE;
  constructor(public payload: any) {}
}
export class CreateNewVisitorInvite implements Action {
  readonly type = CalendarActionTypes.CREATE_NEW_VISITOR_INVITE;
  constructor(public payload: any) {}
}
export class CreateNewVisitorInviteSuccess implements Action {
  readonly type = CalendarActionTypes.CREATE_NEW_VISITOR_INVITE_SUCCESS;
  constructor(public payload: any) {}
}
export class CreateNewVisitorInviteFailure implements Action {
  readonly type = CalendarActionTypes.CREATE_NEW_VISITOR_INVITE_FAILURE;
  constructor(public payload: any) {}
}
export class SetContextData implements Action {
  readonly type = CalendarActionTypes.SET_CONTEXT_DATA;
  constructor(public payload: any) {}
}
export class CancelVisitorInvite implements Action {
  readonly type = CalendarActionTypes.CANCEL_VISITOR_INVITE;
  constructor(public payload: any) {}
}
export type CyclopsCalendarActionUnion =
  | ResetState
  | InitVisitorCalendar
  | InitIncidentCalendar
  | GetCalendarDimensions
  | GetTimeSlots
  | GetTimeSlotsSuccess
  | GetTimeSlotsFailure
  | CheckExistingVisitor
  | CheckExistingVisitorSuccess
  | CheckExistingVisitorFailure
  | SelectedDateTimeSlot
  | InitVisitorInvite
  | CreateNewVisitorInvite
  | CreateNewVisitorInviteSuccess
  | CreateNewVisitorInviteFailure
  | SetContextData
  | GetHosts
  | GetHostsSuccess
  | GetHostsFailure
  | CancelVisitorInvite
  | HostVisitorVerify
  | HostVisitorVerifySuccess
  | HostVisitorVerifyFailure;
